export const FUNNEL_STAGES = [
  'DISPARADAS',
  'RECEBIDAS',
  'LIDAS',
  'RESPONDERAM',
  'ACORDO_FECHADO',
] as const;

export type FunnelStage = (typeof FUNNEL_STAGES)[number];

export interface FunnelStageCount {
  stage: FunnelStage;
  total: number;
}

export const FUNNEL_STAGE_SLUGS: Record<FunnelStage, string> = {
  DISPARADAS: 'disparadas',
  RECEBIDAS: 'recebidas',
  LIDAS: 'lidas',
  RESPONDERAM: 'responderam',
  ACORDO_FECHADO: 'acordo-fechado',
};

export const FUNNEL_STAGE_LABELS: Record<FunnelStage, string> = {
  DISPARADAS: 'Disparadas',
  RECEBIDAS: 'Recebidas',
  LIDAS: 'Lidas',
  RESPONDERAM: 'Responderam',
  ACORDO_FECHADO: 'Acordo fechado',
};

export const ENGAGEMENT_CATEGORIES = [
  'RECEPTIVO',
  'HESITANTE',
  'RELUTANTE',
  'CONTESTADOR',
] as const;

export type EngagementCategory = (typeof ENGAGEMENT_CATEGORIES)[number];

export const ENGAGEMENT_CATEGORY_SLUGS: Record<EngagementCategory, string> = {
  RECEPTIVO: 'receptivo',
  HESITANTE: 'hesitante',
  RELUTANTE: 'relutante',
  CONTESTADOR: 'contestador',
};

export interface EngagementProfile {
  totalClassified: number;
  categories: {
    categoria: EngagementCategory;
    total: number;
  }[];
}

export interface DashboardCaseListItem {
  id: string;
  counterpartyName: string;
  numeroNegociacao: string | null;
  status: string;
}

export interface DashboardCasesPage {
  items: DashboardCaseListItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface GeneralDashboard {
  block1: {
    responseRate: number;
    activeBase: number;
    avgResponseTimeMs: number;
    totalNegotiations: number;
    cpfsUnicos: number;
    avgTimeToAgreementMs: number | null;
    responseAttempts: {
      firstAttempt: number;
      secondAttempt: number;
      thirdPlusAttempt: number;
    };
  };
  block2: {
    responseRateByHour: {
      hour: string;
      responseRate: number;
    }[];
    responseRateByDay: {
      day: string;
      responseRate: number;
    }[];
    bestHour: {
      hour: string;
      responseRate: number;
    };
    bestDays: {
      day: string;
      responseRate: number;
    }[];
  };
  block3: {
    sentPercentage: number;
    totalNegotiations: number;
    totalActive: number;
    activePercentage: number;
    totalSeen: number;
    seenPercentage: number;
    totalDelivered: number;
    deliveredPercentage: number;
  };
  funnel: FunnelStageCount[];
}

export interface QualitativeDashboard {
  responseText: {
    objections: {
      label: string;
      percentage: number;
      suggestion: string;
    }[];
    questions: {
      label: string;
      percentage: number;
      example: string;
    }[];
    topTerms: string[];
    sentiment: {
      negative: number;
      neutral: number;
      positive: number;
    };
    lastUpdateAt: string;
  };
  engagementProfile?: EngagementProfile;
}
